import Enterprises from './enterprises'
import EmailSettings from './email-settings'
import SSOConfiguration from './sso-configuration'

import EnterpriseDashboard from './enterprise/dashboard'
import EnterpriseMembers from './enterprise/members'
import EnterpriseMember from './enterprise/member'
import EnterpriseGroups from './enterprise/groups'
import EnterprisePolicies from './enterprise/policies'
import EnterpriseActivityLogs from './enterprise/activity-logs'

export default {
  Enterprises,
  EmailSettings,
  SSOConfiguration,

  EnterpriseDashboard,
  EnterpriseMembers,
  EnterpriseMember,
  EnterpriseGroups,
  EnterprisePolicies,
  EnterpriseActivityLogs
}